import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificados-cursos-contables',
  templateUrl: './certificados-cursos-contables.component.html',
  styleUrls: ['./certificados-cursos-contables.component.scss']
})
export class CertificadosCursosContablesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
